import { render, staticRenderFns } from "./PanelLayout.vue?vue&type=template&id=5c05c948&"
import script from "./PanelLayout.vue?vue&type=script&lang=ts&"
export * from "./PanelLayout.vue?vue&type=script&lang=ts&"
import style0 from "./PanelLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports